<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-6 py-4">
    <div class="flex justify-between">
      <p class="text-primary font-semibold fsize20 sm-fsize18">
        {{ getAllCategory.result[0].playlist_count }} playlists
      </p>
      <!-- <feather-icon
        icon="MoreHorizontalIcon"
        class="text-primary"
        svgClasses="w-5 h-5 ml-1"
      ></feather-icon> -->
    </div>
    <div v-for="item in getAllCategory.result[0].playlistId" :key="item._id">
      <hr class="mt-2" />
      <div
        @click="handleRedirect(item._id)"
        class="lg:flex md:flex gap-4 lg:px-8 md:px-8 px-6 lg:py-6 md:py-6 py-4 cursor-pointer"
      >
        <div class="w-60per sm-wfull lg:pb-0 md:pb-0 pb-4">
          <p class="fsize20 sm-fsize18 font-semibold clr-black">
            {{ item.name }}
          </p>
          <p class="py-2 sm-fsize14">
            {{ item.description }}
          </p>
          <p class="fsize14 sm-fsize12">{{ item.episode_count }} episodes</p>
        </div>
        <div class="w-40per sm-wfull">
          <!-- <iframe class="scrnht-200 w-full" src="" frameborder="0"></iframe> -->
          <img
            class="scrnht-250 w-full rounded-xl object-cover"
            :src="handleFrame(item.episodes[0].video_url)"
            alt="img"
          />
        </div>
      </div>
    </div>
    <!-- <div class="lg:px-8 md:px-8 px-6 lg:py-6 md:py-6 py-4">
      <div class="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-6">
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="lg:h-52 md:h-52 h-40 w-full rounded-xl"
        />
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="lg:h-52 md:h-52 h-40 w-full rounded-xl"
        />
        <img
          src="https://nexuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
          alt="img"
          class="lg:h-52 md:h-52 h-40 w-full rounded-xl"
        />
      </div>
      <router-link :to="'/videospage'">
        <div class="flex items-center justify-end gap-2 clr-cd45af pt-4 cursor-pointer">
          <p class="font-semibold sm-fsize14">Watch More</p>

          <feather-icon
            icon="ArrowRightIcon"
            class="clr-cd45af"
            svgClasses="w-5 h-5 "
          ></feather-icon>
        </div>
      </router-link>
    </div> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("playlist", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    handleFrame(url) {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    },
    handleRedirect(id) {
      this.$router.push({
        name: "videospage",
        query: {
          playlistId: id,
        },
      });
    },
  },
  async mounted() {
    try {
      // let data = await this.$store.dispatch("playlist/getall_category", {
      //   cid: this.$route.query.cid,
      // });
    } catch (error) {}
  },
};
</script>
